
















































import BaseInput from '../models/base.input';
import {Prop, Watch, Component} from 'vue-property-decorator';

@Component({})
export default class GridCodeInput extends BaseInput {
    @Prop() public value!: string;
    @Prop() public name: string | undefined;
    @Prop() public cols: number | undefined;
    @Prop() public labelCols: number | undefined;
    @Prop() public error: string | undefined;
    @Prop() public editable: boolean | undefined = false;

    private ion: string = '';
    private num: string = '';
    private crc: string = '';

    @Watch('value')
    setCodeValues() {
        this.ion = this.value.substring(0, 4);
        this.num = this.value.substring(4, 17);
        this.crc = this.value.substring(17, 19);
    }

    codeChanged() {
        this.$emit('changed', this.ion + this.num + this.crc);
    }
}
